import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router";

import { HELP_CALL_PARKING } from "@/constants/HelpUrls";
import MasterDetail from "@/design/layouts/MasterDetail";
import { setHelpUrl } from "@/store/reducers/ui";

import { useHotkey } from "@tanstack/react-hotkeys";

import CallParking from "./CallParking";
import CallParkingList from "./CallParkingList";

export default function CallParkings() {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setHelpUrl(HELP_CALL_PARKING));
  }, [dispatch]);

  useHotkey("Alt+N", () => navigate(`/pbx/${params.pbxId}/call-flow/call-parkings/new`));

  return <MasterDetail identifier="id" master={<CallParkingList />} detail={<CallParking />} />;
}
